import { render, staticRenderFns } from "./PregnacyView.vue?vue&type=template&id=1a6f3feb&scoped=true&"
import script from "./PregnacyView.vue?vue&type=script&lang=js&"
export * from "./PregnacyView.vue?vue&type=script&lang=js&"
import style0 from "./PregnacyView.vue?vue&type=style&index=0&id=1a6f3feb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f3feb",
  null
  
)

export default component.exports